/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { useShallow } from 'zustand/shallow';
import { TChannelModalRootTypes, useChannelModalRootStore } from './channel-modal-root.store';
import DeleteAppStoreChannelModal from '@/features/channels/app-store/components/modals/delete-app-store-channel-modal/delete-app-store-channel-modal';
import SelectConnectAppStoreChannelModal from '@/features/channels/app-store/components/modals/select-connect-app-store-channel-modal/select-connect-app-store-channel-modal';
import SendCredentialAppStoreChannelModal from '@/features/channels/app-store/components/modals/send-credential-app-store-modal/send-credential-app-store-modal';
import DeleteGooglePlayStoreChannelModal from '@/features/channels/google-play-store/components/modals/delete-google-play-store-channel-modal/delete-google-play-store-channel-modal';
import AddGooglePlayStoreApkModal from '@/features/channels/google-play-store/components/modals/add-google-play-store-apk-modal/add-google-play-store-apk-modal';
import AddLocationGoogleReviewModal from '@/features/channels/google-review/components/modals/add-location-google-review-modal/add-location-google-review-modal';
import DeleteLocationGoogleReviewModal from '@/features/channels/google-review/components/modals/delete-location-google-review-modal/delete-location-google-review-modal';
import DeleteIntegrationLineModal from '@/features/channels/chat-platform/line/components/modals/delete-integration-line-modal/delete-integration-line-modal';
import DeleteIntegrationWhatsappModal from '@/features/channels/chat-platform/whatsapp/components/modals/delete-integration-whatsapp-modal/delete-integration-whatsapp-modal';
import GetQrWhatsappModal from '@/features/channels/chat-platform/whatsapp/components/modals/get-qr-whatsapp-modal/get-qr-whatsapp-modal';
import SwitchConnectWhatsappModal from '@/features/channels/chat-platform/whatsapp/components/modals/switch-connect-whatsapp-modal/switch-connect-whatsapp-modal';
import AddPageMetaModal from '@/features/channels/social-media/meta/components/modal/add-page-meta-modal/add-page-meta-modal';
import DeleteIntegrationMetaModal from '@/features/channels/social-media/meta/components/modal/delete-integration-meta-modal/delete-integration-meta-modal';
import DeleteIntegrationXModal from '@/features/channels/social-media/x/components/modals/delete-integration-x-modal/delete-integration-x-modal';
import DeleteThreadsChannelModal from '@/features/channels/social-media/threads/components/modals/delete-threads-channel-modal';
import DeleteTiktokChannelModal from '@/features/channels/social-media/tiktok/components/modals/delete-tiktok-channel-modal';
import DeleteIntegrationYoutubeModal from '@/features/channels/youtube/components/modals/delete-integration-youtube-modal/delete-integration-youtube-modal';

const modalMap: Partial<Record<TChannelModalRootTypes, React.ComponentType<any>>> = {
  // App Store Channel Modal
  DeleteAppStoreChannelModal,
  SelectConnectAppStoreChannelModal,
  SendCredentialAppStoreChannelModal,

  // Google Play Store Channel Modal
  DeleteGooglePlayStoreChannelModal,
  AddGooglePlayStoreApkModal,

  // Google Review Channel Modal
  AddLocationGoogleReviewModal,
  DeleteLocationGoogleReviewModal,

  // Line Channel Modal
  DeleteIntegrationLineModal,

  // WhatsApp Channel Modal
  DeleteIntegrationWhatsappModal,
  GetQrWhatsappModal,
  SwitchConnectWhatsappModal,

  // Social Media Meta Channel Modal
  AddPageMetaModal,
  DeleteIntegrationMetaModal,

  // Social Media X Channel Modal
  DeleteIntegrationXModal,

  // Social Media Threads Channel Modal
  DeleteThreadsChannelModal,

  // Social Media TikTok Channel Modal
  DeleteTiktokChannelModal,

  // YouTube Channel Modal
  DeleteIntegrationYoutubeModal,
};

// Memoize valid types to avoid recreating on every render
const validChannelModalTypes = Object.keys(modalMap) as TChannelModalRootTypes[];

const ChannelModalRoot = memo(() => {
  // Optimized: Only subscribe to modals that belong to this root
  // This prevents re-renders when other modal roots change
  const modals = useChannelModalRootStore(
    useShallow((state) => state.modals.filter((modal) => validChannelModalTypes.includes(modal.type)))
  );

  // RENDER
  return (
    <>
      {modals.map(({ type, props }, idx) => {
        const ModalComponent = modalMap[type];
        const key = `${type}-${idx + 1}`;

        if (!ModalComponent) return null;

        return <ModalComponent key={key} {...props} />;
      })}
    </>
  );
});
ChannelModalRoot.displayName = 'ChannelModalRoot';
export default ChannelModalRoot;
